import "./App.css";
import ForgotPassword from "./Pages/ForgotPassword";
import VerifyEmail from "./Pages/VerifyEmail";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import NotFound from "./Pages/NotFound";
import { development_mode } from "./services/Constant";
const route = development_mode ? "test-authorization" : "authorization";
const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path={`/${route}/reset-password/:fp_token`}
          element={<ForgotPassword />}
        />
        <Route
          path={`/${route}/verify-email/:ev_token`}
          element={<VerifyEmail />}
        />

        <Route path="*" element={<NotFound />} />
        

      </Routes>
    </BrowserRouter>

  );
}

export default App;
